function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33335C2.5 5.19085 2.5 3.61919 3.47667 2.64335C4.45333 1.66752 6.02417 1.66669 9.16667 1.66669H10.8333C13.9758 1.66669 15.5475 1.66669 16.5233 2.64335C17.4992 3.62002 17.5 5.19085 17.5 8.33335V11.6667C17.5 14.8092 17.5 16.3809 16.5233 17.3567C15.5467 18.3325 13.9758 18.3334 10.8333 18.3334H9.16667C6.02417 18.3334 4.4525 18.3334 3.47667 17.3567C2.50083 16.38 2.5 14.8092 2.5 11.6667V8.33335Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 6.54712H13.3346M6.66797 9.88045H10.8346",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 13.3713H13.3346",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.df072fc2c77a416d332fb4d006d8e294.svg";
export { ForwardRef as ReactComponent };